var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrownFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "points icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4307",
    d: "M2 4.86403L6 8.23951L8 2.61719L10 8.23951L14 4.86403L12 11.6172H4L2 4.86403Z",
    fill: "white",
    stroke: "#EAAA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4306",
    d: "M1 6.0984L5 9.47388L7 3.85156L9 9.47388L13 6.0984L11 12.8516H3L1 6.0984Z",
    fill: "#EAAA00"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 325",
    x1: 3,
    y1: 13.8828,
    x2: 12,
    y2: 13.8828,
    stroke: "#EAAA00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownFill);
export default __webpack_public_path__ + "static/media/crown-fill.12770b29b50f8407f42ad21fc5acaac6.svg";
export { ForwardRef as ReactComponent };